import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class ContractsModel extends BaseModel {
  static urlPath = "contracts";

  @attr("string") contractName;
  @attr("string") startDate;
  @attr("string") termDate;
  @attr("string") employerIdentificationNumber;
  @attr("boolean") pipState;
  @attr("string") contractFile;
  @attr("string") contractFileName;
  @attr("string") entity;
}
